import Class from '@/Class';
import { IMessageParameters } from '#/CoreFrameInterfaces';

export default class Message extends Class {
    public context: any;

    public constructor(params: IMessageParameters) {
        super();
        if (params) {
            this.context = this.paramOrDefault(params.context, null);
        }
        this.undisposeProperties.push('context');
    }
}